import React from 'react';

import SingleDay from './SingleDay';
import Loading from '../shared/Loading';
import { m } from '../../utils';

const Calendar = ({
  bookingDetail,
  bookings,
  cars,
  duration,
  daysInWeek = [],
  handleTimeSlotClick,
  isDashboard,
  isDoubleShift,
  selectedShifts,
  shifts,
  startTime,
  tier,
  toggleShiftList,
  upcomingShift,
  vehicleAvailability,
  loading,
  error,
}) => {
  if (loading) return <Loading size="3x" />;
  if (error) return error;

  return (
    <div className="weekly-calendar">
      {daysInWeek.map(day => (
        <SingleDay
          bookingDetail={bookingDetail}
          bookings={bookings}
          cars={cars[`${m(day).format('YYYY-MM-DD')}`]}
          day={day}
          duration={duration}
          handleTimeSlotClick={handleTimeSlotClick}
          isDashboard={isDashboard}
          isDoubleShift={isDoubleShift}
          key={m(day).format('YYYYMMDD')}
          selectedShifts={selectedShifts}
          shifts={shifts}
          startTime={startTime}
          tier={tier}
          toggleShiftList={toggleShiftList}
          upcomingShift={upcomingShift}
          vehicleAvailability={vehicleAvailability}
        />
      ))}
    </div>
  );
};

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/WeeklyCalendar/Calendar.js